import { Link } from 'react-router-dom';

function NavBarTheme() {
  return (
    <div className="col-auto col-md-3 col-xl-2 px-sm-1 px-0 bg-light">
      <div className="d-flex flex-column align-items-center align-items-sm-start px-3 pt-2 text-white min-vh-100">
        <ul className="nav nav-pills flex-column mb-sm-auto mb-0 align-items-center align-items-sm-start" id="menu">
            <li className="nav-item">
                <Link to="/" className="nav-link align-middle px-0 link-secondary">
                  <span className="ms-1 d-none d-sm-inline">Create Profile</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="/modulelist" className="nav-link align-middle px-0 link-secondary">
                  <span className="ms-1 d-none d-sm-inline">Select Module</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="/pathwayselection" className="nav-link align-middle px-0 link-secondary">
                  <span className="ms-1 d-none d-sm-inline">Select Pathway</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="/themestormer" className="nav-link align-middle px-0">
                  <span className="ms-1 d-none d-sm-inline fw-bolder text-decoration-underline">Select Theme</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="#" className="nav-link align-middle px-0 link-secondary">
                  <span className="ms-1 d-none d-sm-inline">Select Project</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link to="#" className="nav-link align-middle px-0 link-secondary">
                  <span className="ms-1 d-none d-sm-inline">Select Sprites & Backdrop</span>
                </Link>
            </li>
        </ul>
      </div>
    </div>
  );
}

export default NavBarTheme;